import { usePagination } from './usePagination'

export const useMultiplePagination = (state) => {
  const siteDetailsPagination = usePagination(state)
  const ecosystemPagination = usePagination(state)
  const speciePagination = usePagination(state)
  const threatsPagination = usePagination(state)
  const usersPagination = usePagination(state)
  const speciesGlobalPagination = usePagination(state)
  const predefinedPagination = usePagination(state)
  const allSpeciesPagination = usePagination(state)
  const oldSpeciesPagination = usePagination(state)
  const newSpeciesPagination = usePagination(state)

  return {
    siteDetailsPagination,
    ecosystemPagination,
    speciePagination,
    threatsPagination,
    usersPagination,
    speciesGlobalPagination,
    predefinedPagination,
    allSpeciesPagination,
    oldSpeciesPagination,
    newSpeciesPagination
  }
}
